import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { getTickmillCompanyNameByType } from 'api/Clients/Types/TickmillCompanyTypes'
import { Link } from 'components/Link'
import { links } from 'utils/featureToggles'

import { StatusIconFactory } from './SearchStatusIcon'

export const ClientColumnDefinition: GridColumnProps[] = [
  {
    title: 'Name',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.value) {
        return <td />
      }
      if (!props.dataItem?.id) {
        return <td />
      }

      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsClients.detailsUrl as string, {
                id: props.dataItem.id,
                slug: 'details',
              }),
            }}
          >
            {props.dataItem.data.firstName} {props.dataItem.data?.middleName || ''}{' '}
            {props.dataItem.data.lastName}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Email',
    field: 'data.email',
  },
  {
    title: 'Country',
    field: 'data.country.name',
  },
  {
    title: 'Status',
    cell: (props: GridCellProps): JSX.Element => {
      const statusId = props.dataItem?.data?.clientStatus?.id
      if (!props.dataItem?.data?.clientStatus?.name) {
        return <td />
      }
      return (
        <td>
          <span>
            {props.dataItem.data.clientStatus.name} <StatusIconFactory statusId={statusId} />
          </span>
        </td>
      )
    },
  },
  {
    title: 'Entity',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.data?.tickmillCompany?.id) {
        return <td />
      }
      return (
        <td>
          <CompanyTag id={props.dataItem.data.tickmillCompany.id}>
            {getTickmillCompanyNameByType(props.dataItem.data.tickmillCompany.id)}
          </CompanyTag>
        </td>
      )
    },
    width: 80,
    minResizableWidth: 80,
  },
]
